import { Text } from "ink";
import React, { FC } from "react";

import type { Run } from "../execution";

interface ResultsProps {
	run: Run;
}

const Results: FC<ResultsProps> = () => <Text>""</Text>;

export default Results;
